<template>
    <div class="goodShop">
        <i class="iconfont iconicon_dianpu"></i><span>{{ shopName }}</span>
    </div>
</template>

<script>
export default {
    props: {
        shopName: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
.goodShop {
    padding: 32px;
    background: #fff;
    display: flex;
    align-items: center;
    span {
        height: 40px;
        line-height: 40px;
        word-wrap: break-word;
        word-break: break-all;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
    }
}
.iconicon_dianpu {
    position: relative;
    top: 1px;
    margin-right: 12px;
    color: #999;
}
</style>